<div class="fixed inset-0 z-50 flex items-center justify-center">

  <!-- Background Overlay -->
  <div
    class="absolute inset-0 bg-[#363738] bg-opacity-30 backdrop-blur-sm transition-opacity dark:bg-[#00000080]"
    (click)="closeModal()">
  </div>

  <!-- Modal Container -->
  <div
    class="relative w-full max-w-md mx-4 rounded-xl border border-zinc-200 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950 transition-all duration-300 scale-100">

    <!-- Header -->
    <div class="flex items-center justify-between border-b border-zinc-200 px-6 py-4 dark:border-white/10">
      <div class="flex items-center">
        <svg class="mr-3 h-5 w-5 text-main-primary" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 4h12v2H4V4zm0 5h12v2H4V9zm0 5h8v2H4v-2z"/>
        </svg>
        <h2 class="text-lg font-semibold text-main-primary">
          Add Payment Card
        </h2>
      </div>

      <!-- Close Button -->
      <button
        (click)="closeModal()"
        class="text-zinc-500 hover:text-red-500 dark:text-zinc-400 transition">
        ✕
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 py-6">
      <div id="payment-form">
    <div id="payment-status-container"></div>
    <div id="card-container"></div>
    <button
        (click)="pay()"
        class="w-full btn btn-secondary rounded-lg">
        Submit
      </button>
  </div>


     

    </div>

  </div>
</div>